/* eslint-disable no-useless-escape */
import React, { useEffect } from 'react'
import { Navbar } from './Navbar';
import {
    Container, CssBaseline, Paper, FormControl, InputLabel,
    Button, Grid, TextField, Select,
    Box, CircularProgress
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { Footer } from './Footer';
import logo from "./logo192.png";
import bg from "./bg.jpg";
import { useStateIfMounted } from 'use-state-if-mounted';
import UserService from "./services/user.service";

import { useParams, useHistory } from "react-router-dom";
import {
    MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import th from 'date-fns/locale/th';

import SliderCaptcha from '@slider-captcha/react';

import { config } from './config';
export const Register = () => {
    const { accept } = useParams();
    let history = useHistory();


    const [loading, setLoading] = useStateIfMounted(false);
    const [finish, setFinish] = useStateIfMounted(false);
    const [message, setMessage] = useStateIfMounted("");
    const [titleName, setTitleName] = useStateIfMounted(null);
    const [firstName, setFirstName] = useStateIfMounted(null);
    const [lastName, setLastName] = useStateIfMounted(null);
    const [organizationName, setOrganizationName] = useStateIfMounted(null);
    const [affiliation, setAffiliation] = useStateIfMounted(null);

    const [provinces, setProvinces] = useStateIfMounted([]);
    const [amphurs, setAmphurs] = useStateIfMounted([]);
    const [provinceId, setProvinceId] = useStateIfMounted(null);
    const [provinceName, setProvinceName] = useStateIfMounted(null);
    const [amphurId, setAmphurId] = useStateIfMounted(null);
    const [amphurName, setAmphurName] = useStateIfMounted(null);

    const [mobile, setMobile] = useStateIfMounted(null);
    const [loanAmount, setLoanAmount] = useStateIfMounted(null);
    const [captcha, setCaptcha] = useStateIfMounted(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(async () => {
        if (accept !== 'accept') {
            history.push('/');
        }
        window.scrollTo(0, 0)
        let resp = await UserService.getProvinces()
        setProvinces(resp.data)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    const onChangeProvinces = async (e) => {
        const province = e.target.value;
        var index = e.nativeEvent.target.selectedIndex;
        setProvinceId(provinces[index - 1].provinceId)
        setProvinceName(provinces[index - 1].provinceName)
        let resp = await UserService.getAmphurs(province)
        setAmphurs(resp.data)

    };

    const onChangeAmphurs = async (e) => {
        const amphur = e.target.value;
        var index = e.nativeEvent.target.selectedIndex;
        setAmphurId(amphurs[index - 1].amphurId)
        setAmphurName(amphurs[index - 1].amphurName)

    };


    const verifiedCallback = (token) => {
        // console.log('Captcha token: ' + token);
        if (token !== null) {
            setCaptcha(token)
        } else {
            setCaptcha(null)
        }
    }


    function checkSpecialCharacter(value) {
        let data = value.toString()
        if (data == null) {
            return data;
        }

        return data.replace(/[&\/\\#, +()$~%|@!^.'":*?<>{}]/g, '');;
    }


    const handleSubmit = async (event) => {
        event.preventDefault();

        setMessage("")
        setLoading(true)

        let register = {}

        register.titleName = titleName
        register.firstName = checkSpecialCharacter(firstName)
        register.lastName = checkSpecialCharacter(lastName)
        register.mobile = checkSpecialCharacter(mobile)
        register.organizationName = checkSpecialCharacter(organizationName)
        register.affiliation = checkSpecialCharacter(affiliation)
        register.amphurId = checkSpecialCharacter(amphurId)
        register.amphurName = checkSpecialCharacter(amphurName)
        register.provinceId = checkSpecialCharacter(provinceId)
        register.provinceName = checkSpecialCharacter(provinceName)
        register.loanAmount = loanAmount

        try {
            let resp = await UserService.postAdd(register)
            if (resp.data.isSuccess === true) {
                setLoading(false)
                setFinish(true)
            } else {
                setLoading(false)
                setMessage(resp.data.message)
            }


        } catch (error) {
            setLoading(false)
            setMessage(error.message)
        }

        // if (resp.data.register === true) {
        //     setFinish(true)
        // } else {
        //     setFinish(false)
        //     setMessage(resp.data.status_message)
        // }



    }
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={th}>
            <React.Fragment>
                <CssBaseline />
                <Navbar></Navbar>

                <Container component="main" maxWidth="sm">



                    <Paper style={{ padding: 20, marginTop: 20 }}>

                        {finish ?
                            <Grid container spacing={3}>
                                <Grid item xs={12} align="center">
                                    <img
                                        alt=""
                                        src={logo}
                                        width="25%"


                                    />
                                </Grid>
                                <Grid item xs={12} >
                                    <Alert variant="filled" severity="success">
                                        ท่านได้ลงทะเบียนเรียบร้อยแล้ว
                                    </Alert>
                                </Grid>
                            </Grid>

                            : <form autoComplete="off" onSubmit={handleSubmit}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} align="center">
                                        <img
                                            alt=""
                                            src={bg}
                                            width="100%"


                                        />
                                    </Grid>


                                    <Grid item xs={12} sm={4}>

                                        <FormControl variant="outlined" required fullWidth>
                                            <InputLabel htmlFor="titleName">คำนำหน้า</InputLabel>
                                            <Select
                                                native

                                                onChange={(e) => setTitleName(e.target.value)}
                                                label="คำนำหน้า"
                                                inputProps={{
                                                    name: 'titleName',
                                                    id: 'titleName',
                                                }}
                                            >
                                                <option aria-label="None" value="" />
                                                <option value={'นาย'}>นาย</option>
                                                <option value={'นาง'}>นาง</option>
                                                <option value={'น.ส.'}>น.ส.</option>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>


                                        <TextField
                                            type="text"
                                            name="firstName"
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="firstName"
                                            label="ชื่อ"
                                            inputProps={{ min: 0, max: 250, pattern: "[^!@#$%^*()<>[\]\\,'|\x22]+" }}
                                            onChange={(e) => setFirstName(e.target.value)}


                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            type="text"
                                            variant="outlined"

                                            required
                                            fullWidth
                                            id="lastName"
                                            label="นามสกุล"
                                            name="lastName"
                                            inputProps={{ min: 0, max: 250, pattern: "[^!@#$%^*()<>[\]\\,'|\x22]+" }}
                                            onChange={(e) => setLastName(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            type="text"
                                            variant="outlined"
                                            required
                                            fullWidth
                                            name="mobile"
                                            label="เบอร์มือถือ"
                                            id="mobile"
                                            inputProps={{ min: 0, max: 10, pattern: "[0-9]{10}" }}
                                            onChange={(e) => setMobile(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>

                                        <TextField
                                            style={{ zIndex: 0 }}
                                            type="text"
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="organizationName"
                                            label={"ชื่อหน่วยงาน"}
                                            name="organizationName"
                                            inputProps={{ min: 0, max: 250, pattern: "[^!@#$%^*()<>[\]\\,'|\x22]+" }}
                                            onChange={(e) => setOrganizationName(e.target.value)}
                                        />

                                    </Grid>
                                    <Grid item xs={12}>

                                        <TextField
                                            style={{ zIndex: 0 }}
                                            type="text"
                                            variant="outlined"
                                            required
                                            fullWidth
                                            id="affiliation"
                                            label={"สังกัด"}
                                            name="affiliation"
                                            inputProps={{ min: 0, max: 250, pattern: "[^!@#$%^*()<>[\]\\,'|\x22]+" }}
                                            onChange={(e) => setAffiliation(e.target.value)}
                                        />

                                    </Grid>

                                    <Grid item xs={12} sm={6} >

                                        <FormControl variant="outlined" required fullWidth>
                                            <InputLabel style={{ zIndex: 0 }} htmlFor="provinces">จังหวัด</InputLabel>
                                            <Select
                                                native

                                                onChange={(e) => onChangeProvinces(e)}
                                                label="จังหวัด"
                                                inputProps={{
                                                    name: 'provinces',
                                                    id: 'provinces',
                                                }}
                                            >
                                                <option aria-label="None" value="" />
                                                {
                                                    provinces.map((item, index) => (

                                                        <option key={index} value={item.provinceId} >{item.provinceName}</option>
                                                    ))

                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >

                                        <FormControl variant="outlined" required fullWidth>
                                            <InputLabel style={{ zIndex: 0 }} htmlFor="amphurs">อำเภอ</InputLabel>
                                            <Select
                                                native

                                                onChange={(e) => onChangeAmphurs(e)}
                                                label="อำเภอ"
                                                inputProps={{
                                                    name: 'amphurs',
                                                    id: 'amphurs',
                                                }}
                                            >
                                                <option aria-label="None" value="" />
                                                {
                                                    amphurs.map((item, index) => (

                                                        <option key={index} value={item.amphurId} >{item.amphurName}</option>
                                                    ))

                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12}>

                                        <FormControl variant="outlined" required fullWidth>
                                            <InputLabel style={{ zIndex: 0 }} htmlFor="titleName">วงเงินกู้ที่ต้องการ</InputLabel>
                                            <Select
                                                native

                                                onChange={(e) => setLoanAmount(e.target.value)}
                                                label="วงเงินกู้ที่ต้องการ"
                                                inputProps={{
                                                    name: 'creaditAmount',
                                                    id: 'creaditAmount',
                                                }}
                                            >
                                                <option aria-label="None" value="" />
                                                <option value={'100000'}>100,000</option>
                                                <option value={'200000'}>200,000</option>
                                                <option value={'300000'}>300,000</option>
                                                <option value={'400000'}>400,000</option>
                                                <option value={'500000'}>500,000</option>
                                            </Select>
                                        </FormControl>
                                    </Grid>


                                    {message && (
                                        <Grid item xs={12} >
                                            <Alert variant="filled" severity="error" >
                                                {message}
                                            </Alert>
                                        </Grid>
                                    )
                                    }

                                    <Grid item xs={12} align="center" >
                                        <SliderCaptcha
                                      
                                            variant={'light'}
                                            create={config.API_URL + "captcha/create"}
                                            verify={config.API_URL + "captcha/verify"}
                                            callback={verifiedCallback}
                                        />

                                    </Grid>
                                    {captcha !== null && (
                                        <Grid item xs={12} align="center">
                                            <Button
                                                type="submit"
                                                disabled={loading}
                                                variant="contained"
                                                color="primary"

                                            >
                                                {loading && (
                                                    <CircularProgress color="primary" size={24} />
                                                )}
                                                <span>ลงทะเบียน</span>

                                            </Button>
                                        </Grid>
                                    )}

                                </Grid>




                            </form>}

                    </Paper>


                    <Box mt={5}>
                        <Footer />
                    </Box>

                </Container>
            </React.Fragment>
        </MuiPickersUtilsProvider>
    )
}
